/**
 * Очищает объект от undefined, null и пустых строк.
 * Полезно для подготовки параметров запроса.
 */
export const cleanParams = <T extends Record<string, any>>(params: T): Partial<T> => {
    const cleaned = { ...params };
    Object.keys(cleaned).forEach((key) => {
        const value = cleaned[key];
        if (value === undefined || value === null || value === '') {
            delete cleaned[key];
        }
        // Если это 0, обычно мы хотим его оставить (например, id=0), 
        // но в этом проекте часто 0 используется как "не выбрано".
        // Проверим по контексту позже. Пока оставим 0.
    });
    return cleaned;
};
